import React from "react";

const CtaSection = (props) => {
    return (
        <section className={"" +props.hclass} style={{ marginTop: '100px' }}>
            <div className="container">
                <div className="wpo-subscribe-wrap">
                    <div className="subscribe-text">
                        <h3>Abonnez-vous à notre newsletter pour recevoir
                            les dernières actualités sur nos services.</h3>
                    </div>
                    <div className="subscribe-form">
                        <form>
                            <div className="input-field">
                                <input type="email" placeholder="Entrez votre email" required />
                                    <button type="submit">S'abonner</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div> 
        </section>
    )
}
export default CtaSection;


